// 媒体资源路径解析
// 约定：数据库只存站点相对路径（如 /articles/images/2026/07/24/xxx.jpg），
// 域名由前端按环境拼接。生产环境前端与图片同源，MEDIA_BASE 留空，浏览器自动基于当前域名补全；
// 开发环境把 VUE_APP_MEDIA_BASE_URL 指向 MinIO 可访问地址即可。

const MEDIA_BASE = (process.env.VUE_APP_MEDIA_BASE_URL || '').replace(/\/$/, '')

// 把相对/绝对路径解析为可访问的完整 URL
export function resolveMediaUrl(url) {
  if (!url) return url
  if (/^https?:\/\//i.test(url)) return url // 兼容存量完整 URL
  return MEDIA_BASE + (url.startsWith('/') ? url : '/' + url)
}

// 处理富文本正文里的 <img>，把相对路径 src 拼成完整 URL
export function resolveContentImages(html) {
  if (!html) return html
  const doc = new DOMParser().parseFromString(html, 'text/html')
  doc.querySelectorAll('img').forEach((img) => {
    const src = img.getAttribute('src')
    if (src && !/^https?:\/\//i.test(src)) {
      img.setAttribute('src', resolveMediaUrl(src))
    }
  })
  return doc.body.innerHTML
}
